/* @flow */
import ConfirmDialog from 'components/ConfirmDialog';
import Glyph from 'components/Glyph';
import Group from 'entities/Group';
import GroupActions from 'groups/actions/GroupActions';
import ModalMenuItem from 'components/ModalMenuItem';
import * as React from 'react';
import ToastActions from 'actions/ToastActions';
import errorLogger from 'utils/errorLogger';

type Props = {
  group: ?Group,
  user: {
    id: string | number,
    name: string,
  },
  disabled?: boolean,
  onRemove?: Function,
};

class RemoveMemberMenuItem extends React.Component<Props> {
  removeMember = () => {
    const { group, onRemove, user } = this.props;

    if (group && user) {
      const message = `${user.name} was removed from ${group.getName()}`;
      GroupActions.removeMember(group, user)
        .then(() => {
          if (onRemove) {
            onRemove();
          }
          ToastActions.showSuccessToast(message);
        })
        .catch(e => {
          const errorMessage =
            e.message || `An error occured removing user from ${group.getName()}.`;
          ToastActions.showErrorToast(errorMessage);
          errorLogger('RemoveMemberMenuItem removeMember failed');
        });
    }
  };

  renderConfirmDialog = () => {
    return (
      <ConfirmDialog
        eventScreenName="RemoveMemberMenuItem"
        actionButtonText="Remove"
        cancelButtonText="Cancel"
        size="xsmall"
        onConfirm={this.removeMember}
        title="Remove participant?"
        subtext={
          'This person won’t receive announcements or be available ' +
          'for direct messaging. You can always change this later.'
        }
      />
    );
  };
  render() {
    return (
      <ModalMenuItem
        modal={this.renderConfirmDialog()}
        disabled={this.props.disabled}
        data-test-selector="remove-member-menu-item"
        {...this.props}>
        <Glyph name="close" />
        <span>Remove from class</span>
      </ModalMenuItem>
    );
  }
}
export default RemoveMemberMenuItem;
